
angular.module('ui.simplePagination', ['ui.bootstrap']);
